import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import { AppEvents, QUERY_KEYS } from 'src/constants'
import StepService from 'src/services/steps.service'
import { IRemoveStepAccountsConnectionDto } from 'src/types'

const useRemoveAccountStepsConnections = (invalidateQuery: boolean = false) => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    (dto: IRemoveStepAccountsConnectionDto) => StepService.removeAccountConnections(dto),
    {
      async onSuccess(data) {
        if (!data) return

        const detail = { message: data.message }
        const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
        document.dispatchEvent(event)
        queryClient.invalidateQueries(QUERY_KEYS.STEPS)
        if (invalidateQuery) {
          queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_STEPS_CONNECTION, accountId])
        }
      },
    },
  )
}

export { useRemoveAccountStepsConnections }
